class ClientSelectedFiltersBuilder {  
  static build(filterEngine) {
    const result = [];
    
    const selectedMap = filterEngine.uiState.selectedValueIdsByFieldId;
    const fieldValueLookup = filterEngine.indexes.fieldValueLookupById;
    const fieldLookup = filterEngine.indexes.fieldsById;

    selectedMap.forEach((valueIds, fieldId) => {
      const field = fieldLookup.get(fieldId);
      valueIds.forEach((valueId) => {
        const fieldValueObj = fieldValueLookup.get(valueId);

        if (!field || !fieldValueObj) {
          return;
        }

        result.push({
          setFieldId: fieldId,
          fieldCode: field.fieldCode,
          fieldName: field.fieldName,
          fieldValueId: fieldValueObj.setFieldValueId,
          fieldValue: fieldValueObj.fieldValue,
          primaryId: fieldValueObj.primaryId,
        });
      });
    });

    return result;
  }
}

export default ClientSelectedFiltersBuilder;
